/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, w) {
	'use strict';
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater,
	 * jquery.placeholder.min.js,
	 */

	var INVISIBLE_CLASS = 'invisible';

	Tc.Module.Scene7 = Tc.Module.extend({

		/*
		 * Global properties for all scene7 components
		 */
		GLOBAL: {
			initialized: false,
			initializing: false
		},

		STYLE: {
			'default': 'default',
			type1: 'type1'
		},

		init: function ($ctx, sandbox, modId) {
			var mod = this;

			mod.$ctx = $ctx;
			mod.$ctx.addClass('normalView');
			mod.mediaSetConfiguration = mod.$ctx.data('references').split(',');
			mod.templateParameters = mod.$ctx.data('template-params');
			mod.elements = {
				zoomButton: $('.zoomButton', mod.$ctx),
				spinsetSpinner: $('.spinsetSpinner', mod.$ctx),
				containerScene7: $('.container-scene7', mod.$ctx),
				videoButton: $('.videoButton', mod.$ctx)
			};
			mod.videoThumbnail = mod.$ctx.data('video-thumbnail');

			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);

			mod.videoButtonOffset = 0;
			mod.videoButtonOffsetType1 = 0;

			// init video button & player
			if (mod.elements.videoButton.length > 0) {
				mod.videoButtonOffset = 55;
				mod.videoButtonOffsetType1 = 65;
				mod.elements.brightcoveVideo = mod.$ctx.find('.modBrightcoveVideo');

				if(mod.videoThumbnail){
					mod.elements.videoButton.css('background-image', 'url(' + mod.videoThumbnail + ')');
				}
			} else {
				mod.elements.videoButton = false;
			}

			mod.size = {
				width: mod.$ctx.data('width'),
				height: mod.$ctx.data('height')
			};
			mod.properties = {
				id: $('.container-scene7', mod.$ctx).attr('id'),
				zoomMode: 'FlyoutZoomView',
				style: mod.$ctx.hasClass('style-' + mod.STYLE.type1) ? mod.STYLE.type1 : mod.STYLE['default']
			};
			mod.s7 = {
				params: {},
				container: {},
				spinview: {},
				zoomview: {},
				flyoutzoomview: {},
				trackingManager: {}
			};
			mod.mediaSets = [];
			mod.spinviewFrameIndex = 0;
			mod.animationSpinviewSpeed = 50;
			mod.spinsetSpinnerExt = 24;
			mod.swatchesHeight = 90;

			// use to start/stop animation 360 view
			mod.visible = true;

			this._super($ctx, sandbox, modId);
		},

		on: function (callback) {
			var mod = this;

			mod.styleElements();

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function () {
				mod.onHide();
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-show', function () {
				mod.onShow();
			});

			mod.$ctx.removeClass(INVISIBLE_CLASS);
			mod.$ctx.removeClass('hidden');
			mod.initializeBase($.proxy(mod.initParameterManager, mod));

			// if no File References are configured, get config via Product Data Hub
			if (!mod.mediaSetConfiguration || !mod.mediaSetConfiguration.join('')) {
				if (mod.sandbox.application.registry.EcommerceProductDataHub) {
					mod.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.productDataChanged);
				}
			}

			callback();
		},

		after: function () {
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				$('body').addClass('safari-browser');
			}
		},

		productDataChanged: function(data) {
			var mod = this;

			mod.log('productDataChanged', data);
			if (!this.GLOBAL.ready) {
				mod.log('productDataChanged - scene7 not yet ready');
				setTimeout(function () {
					mod.productDataChanged(data);
				}, 200);
				return;
			}
			if (!data || !data.product || !data.family) {
				mod.log('productDataChanged - invalid data');
				return;
			}

			var displayedProduct = data.product;

			// find the product with the same color and the smallest memory size
			for (var i = 0; i < data.family.products.length; i += 1) {
				var product = data.family.products[i];
				if (product.getColor() === displayedProduct.getColor() &&
					+product.getMemory() < +displayedProduct.getMemory()) {

					displayedProduct = product;
				}
			}

			var id = displayedProduct.product.code.replace(/^0+/, '');
			if (mod.currentId !== id) {
				mod.currentId = id;
				// Note: "de" must be used for all languages
				mod.updateConfiguration(['Swisscom/scs-' + id + '-de-is']);
			}
		},

		updateConfiguration: function(config) {
			var mod = this;
			mod.log('updateConfiguration', config);
			mod.mediaSetConfiguration = config;
			mod.$ctx.find('.s7swatches').empty();
			mod.mediaSets = [];
			mod.getMediaSet();
		},

		initializeBase: function (callback) {
			if (typeof w.s7sdk !== 'undefined') {
				if (!this.GLOBAL.initialized && !this.GLOBAL.initializing) {
					this.GLOBAL.initializing = true;

					w.s7sdk.Util.lib.include('s7sdk.common.Container');
					w.s7sdk.Util.lib.include('s7sdk.common.Button');
					w.s7sdk.Util.lib.include('s7sdk.set.MediaSet');
					w.s7sdk.Util.lib.include('s7sdk.set.SpinView');
					w.s7sdk.Util.lib.include('s7sdk.set.Swatches');
					w.s7sdk.Util.lib.include('s7sdk.image.ZoomView');
					w.s7sdk.Util.lib.include('s7sdk.image.FlyoutZoomView');
					w.s7sdk.Util.init();

					var params = new w.s7sdk.ParameterManager();
					params.addEventListener(w.s7sdk.Event.SDK_READY, $.proxy(this.overrideS7GetObjRect, this), false);
					params.init();

					this.GLOBAL.initialized = true;
					this.GLOBAL.initializing = false;
					callback();
				} else if (this.GLOBAL.initializing) {
					setTimeout($.proxy(this.initializeBase, this, callback), 500);
				} else {
					callback();
				}
			}
		},

		// Override broken s7sdk.set.Swatches.prototype.getObjRect with an implementation that ignores transforms
		overrideS7GetObjRect: function() {
			var orig = w.s7sdk.set.Swatches.prototype.getObjRect;

			w.s7sdk.set.Swatches.prototype.getObjRect = function getObjRectIgnoringTransforms(el) {
				var $parents = $(el).parents();

				$parents.each(function() {
					var $this = $(this);
					var transform = $this.css('transform') || $this.css('webkit-transform');
					if(transform) {
						this.style.transform = this.style.WebkitTransform = 'none';
					}
				});
				var result = orig.apply(this, arguments);
				$parents.each(function() {
					this.style.transform = this.style.WebkitTransform = '';
				});

				return result;
			};
		},

		initParameterManager: function () {
			var mod = this;
			mod.s7.params = new w.s7sdk.ParameterManager();
			mod.s7.params.setViewer('504,4.7.1');
			mod.s7.params.addEventListener(w.s7sdk.Event.SDK_READY, $.proxy(mod.initViewer, mod), false);
			mod.s7.params.init();
		},

		initViewer: function () {
			var mod = this;
			mod.log('initViewer SDK_READY');
			this.GLOBAL.ready = true;

			// settings for container
			mod.s7.params.push('serverUrl', '//swisscomvbc.scene7.com/is/image/');
			mod.s7.params.push('iscommand', '&resMode=sharp2&op_usm=0.2,0.1,0,0&' + mod.templateParameters);
			mod.s7.params.push('size', mod.size.width + ',' + mod.size.height);
			mod.s7.params.push('zoomfactor', '1');

			// optional Swatches settings
			mod.s7.params.push(mod.properties.id + '-swatches.iscommand', '$thumb$&' + mod.templateParameters);
			mod.s7.params.push(mod.properties.id + '-swatches.tmblayout', '0,1');
			mod.s7.params.push(mod.properties.id + '-swatches.resizable', '0');
			mod.s7.params.push(mod.properties.id + '-swatches.orientation', '0');
			mod.s7.params.push(mod.properties.id + '-swatches.buttonsnapmode', 'snapin');
			mod.s7.params.push(mod.properties.id + '-swatches.tmbsize', '55,55'); // duplicate in $thumb$ preset, does not seem to work if it is only called there ...
			mod.s7.params.push(mod.properties.id + '-swatches.fmt', 'png-alpha'); // duplicate in $thumb$ preset, does not seem to work if it is only called there ...
			if (mod.properties.style === mod.STYLE.type1) {
				mod.s7.params.push(mod.properties.id + '-swatches.cellspacing', '10,10');
			} else {
				mod.s7.params.push(mod.properties.id + '-swatches.cellspacing', '3,3');
			}
			mod.s7.params.push(mod.properties.id + '-swatches.textpos', 'none');
			mod.s7.params.push(mod.properties.id + '-swatches.align', 'center,bottom');
			if (w.s7sdk.browser.device.name !== 'desktop') {
				mod.s7.params.push(mod.properties.id + '-swatches.enablescrollbuttons', '0');
			}

			// optional Spinview settings
			mod.s7.params.push(mod.properties.id + '-spinview.fmt', 'png-alpha');
			mod.s7.params.push(mod.properties.id + '-spinview.doubleclick', 'none'); //disable zoom in spinview

			// optional Zoomview settings
			mod.s7.params.push(mod.properties.id + '-zoomview.zoomfactor', '3,-1');
			mod.s7.params.push(mod.properties.id + '-zoomview.fmt', 'png-alpha');

			// optional Flyout-Zoomview settings
			mod.s7.params.push(mod.properties.id + '-flyoutzoomview.zoomfactor', '3,-1');
			mod.s7.params.push(mod.properties.id + '-flyoutzoomview.fmt', 'png-alpha');

			mod.s7.container = new w.s7sdk.Container(mod.properties.id, mod.s7.params, mod.properties.id + '-s7container');
			mod.s7.spinview = new w.s7sdk.SpinView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-spinview');
			mod.s7.zoomview = new w.s7sdk.image.ZoomView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-zoomview');
			mod.s7.flyoutzoomview = new w.s7sdk.image.FlyoutZoomView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-flyoutzoomview');
			mod.s7.flyoutzoomview.resize();
			mod.s7.flyoutzoomview.addEventListener('click', $.proxy(mod.toggleZoomView, mod));

			mod.s7.trackingManager = new w.s7sdk.TrackingManager();

			mod.s7.spinview.setDragToSpin(true);
			mod.s7.spinview.addEventListener(w.s7sdk.event.AssetEvent.ASSET_CHANGED, $.proxy(mod.spinnerToSliderSync, mod), true);

			mod.elements.zoomButton.on('click', $.proxy(mod.toggleZoomView, mod));
			if (mod.elements.videoButton) {
				mod.elements.videoButton.on('click', $.proxy(mod.onClickVideoButton, mod));
			}

			$(document).keyup(function (e) {
				if (mod.properties.zoomMode === 'ZoomView') {
					if (e.keyCode === 27) { // Esc
						mod.toggleZoomView();
					}
				}
			});

			mod.s7.container.addEventListener(w.s7sdk.ResizeEvent.COMPONENT_RESIZE, $.proxy(mod.onContainerResizeEvent, mod), false);
			mod.s7.container.addEventListener(w.s7sdk.ResizeEvent.WINDOW_RESIZE, $.proxy(mod.onWindowResizeEvent, mod), false);

			mod.getMediaSet();
		},

		getMediaSet: function (i) {
			var mod = this,
				mediaSet;

			i = typeof i === 'undefined' ? 0 : i;
			if (mod.mediaSetConfiguration.length > i) {
				if (mod.mediaSetConfiguration[i] && mod.mediaSetConfiguration[i].length) {
					mod.log('getMediaSet', mod.mediaSetConfiguration[i]);
					mod.s7.params.params.asset = mod.mediaSetConfiguration[i];
					mediaSet = new w.s7sdk.MediaSet(null, mod.s7.params, null);
					mediaSet.addEventListener(w.s7sdk.AssetEvent.NOTF_SET_PARSED, $.proxy(mod.getMediaSet, mod, i += 1), false);
					mod.mediaSets.push(mediaSet);
				} else {
					mod.getMediaSet(i += 1);
				}
			} else {
				mod.onMediaSetsParsed();
			}
		},

		onMediaSetsParsed: function () {
			var mod = this,
				i, j,
				compAsset = new w.s7sdk.MediaSetDesc(0, 0, w.s7sdk.ItemDescType.MEDIA_SET, '', ''),
				mset;

			mod.log('onMediaSetsParsed');
			for (i = 0; i < mod.mediaSets.length; i += 1) {
				if (mod.mediaSets[i]) {
					mset = mod.mediaSets[i].mediaSetDesc_;
					if (mset && mset.type === w.s7sdk.ItemDescType.IMAGE_SET) {
						for (j = 0; j < mset.items.length; j += 1) {
							compAsset.items.push(mset.items[j]);
						}
					} else {
						compAsset.items.unshift(mset);
					}
				}
			}

			// set media set for Swatches to display
			mod.s7.swatches = new w.s7sdk.Swatches(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-swatches');
			mod.s7.swatches.addEventListener(w.s7sdk.AssetEvent.SWATCH_SELECTED_EVENT, $.proxy(mod.swatchSelectedEvent, mod), false);
			mod.s7.swatches.setMediaSet(compAsset);
			if (mod.properties.style === mod.STYLE['default']) {
				mod.s7.swatches.resize(mod.size.width - mod.videoButtonOffset, mod.swatchesHeight);
			} else {
				mod.s7.swatches.resize(mod.size.height - mod.videoButtonOffsetType1, mod.swatchesHeight);
			}

			// select the first swatch or if the #s7 has is set the value instead (starting index is 0)
			if (compAsset.items.length > 0) {
				var hash = SCS.HashDeepLink.get('s7');
				var index = !isNaN(hash) ? hash : 0;
				mod.s7.swatches.selectSwatch(Math.min(Math.abs(index), compAsset.items.length - 1), true);
			}

			/* jshint camelcase: false */
			window.viewer_ASSET_CHANGED = function (e) {
				if ((mod.s7.swatches) && (mod.s7.swatches.frame !== e.s7event.frame)) {
					mod.s7.swatches.selectSwatch(e.s7event.frame, true);
				}
			};

			mod.styleSwatches();

			if (mod.elements.videoButton) {
				mod.elements.videoButton.show();
			}
		},

		// Event from VisibilityControlContainer
		onShow: function () {
			this.visible = true;
		},

		// Event from VisibilityControlContainer
		onHide: function () {
			this.visible = false;
		},

		onClickVideoButton: function () {
			var mod = this;

			if(mod.elements.videoButton.hasClass('selected')) {
				return;
			}

			mod.hideAll();

			mod.$ctx.find('.' + INVISIBLE_CLASS).removeClass(INVISIBLE_CLASS);

			if (mod.s7.swatches) {
				mod.s7.swatches.selectSwatch(-1, false);
			}
			mod.elements.videoButton.addClass('selected');
		},

		hideAll: function () {
			var mod = this;
			// Hide all
			$(mod.s7.flyoutzoomview.obj).hide();
			$(mod.s7.zoomview.obj).hide();
			mod.elements.zoomButton.hide();
			$(mod.s7.spinview.obj).hide();
			mod.elements.spinsetSpinner.hide();

			if (mod.elements.videoButton) {
				mod.elements.videoButton.removeClass('selected');
				mod.elements.brightcoveVideo.addClass(INVISIBLE_CLASS);
			}

		},

		swatchSelectedEvent: function (e) {
			var mod = this,
				asset = e.s7event.asset,
				type = asset.type;

			if (mod.elements.brightcoveVideo) {
				mod.elements.brightcoveVideo.trigger('onPause');
			}

			mod.hideAll();
			mod.elements.zoomButton.show();

			if (+type === 1) { // ImageSet
				// always set asset in both viewers
				mod.s7.flyoutzoomview.setItem(asset);
				mod.s7.zoomview.setItem(asset);

				if (mod.properties.zoomMode === 'ZoomView') {
					$(mod.s7.zoomview.obj).show();
				}

				if (mod.properties.zoomMode === 'FlyoutZoomView') {
					$(mod.s7.flyoutzoomview.obj).show();
				}
				return;
			}

			if (+type === 8) { // SpinView
				mod.s7.params.params.asset = asset.name;
				mod.s7.spinview.setMediaSet(asset);
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
				mod.elements.spinsetSpinner.show();
				mod.elements.spinsetSpinner.slider('destroy').slider({
					animate: 'fast',
					max: mod.s7.spinview.getFramesLength() - 1,
					slide: $.proxy(mod.sliderToSpinnerSync, mod),
					start: $.proxy(mod.sliderStartDrag, mod),
					stop: $.proxy(mod.sliderStopDrag, mod),
					value: mod.spinviewFrameIndex
				});
				$(mod.s7.spinview.obj).show();
				setTimeout($.proxy(mod.setInitialSpinsetSpinviewFrame, mod), 100);
				return;
			}
		},

		setInitialSpinsetSpinviewFrame: function () {
			var mod = this;
			mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
			if (mod.properties.spinview) {
				mod.s7.spinview.resize(mod.properties.spinview.width, mod.properties.spinview.height);
				delete mod.properties.spinview;
			}

			// animation
			if (mod.visible) {
				setTimeout($.proxy(mod.animationSpinview, mod), 500);
			}
		},

		animationSpinview: function () {
			var mod = this;
			if (!mod.visible) {
				return;
			}
			if (mod.spinviewFrameIndex < mod.s7.spinview.getFramesLength()) {
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
				mod.spinviewFrameIndex += 1;
				setTimeout($.proxy(mod.animationSpinview, mod), mod.animationSpinviewSpeed);
			} else {
				mod.spinviewFrameIndex = 0;
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
			}
		},

		onContainerResizeEvent: function (event) {
			var mod = this,
				width = event.s7event.w,
				height = event.s7event.h;

			if (mod.properties.zoomMode === 'ZoomView') {
				height = height - 0 - mod.swatchesHeight;
			}

			if (event.target === mod.s7.container.obj) { // acts only on container resize events
				if (mod.properties.zoomMode === 'ZoomView') {
					mod.s7.swatches.resize(width, mod.swatchesHeight);
				} else {
					if (mod.properties.style === mod.STYLE['default']) {
						mod.s7.swatches.resize(width - mod.videoButtonOffset, mod.swatchesHeight);
					} else {
						mod.s7.swatches.resize(height - mod.videoButtonOffsetType1, mod.swatchesHeight);
					}
				}
				mod.s7.zoomview.resize(width, height);
				if (mod.s7.spinview.getCurrentView()) {
					mod.s7.spinview.resize(width, height);
				} else {
					mod.properties.spinview = {
						width: width,
						height: height
					};
				}
			}
		},

		onWindowResizeEvent: function (event) {
			var mod = this;
			if (mod.properties.zoomMode === 'ZoomView') {
				mod.s7.container.resize(event.s7event.w, event.s7event.h);
			}
		},

		styleSwatches: function () {
			// Parse the swatches element and check for videos / 360 spinsets
			var mod = this,
				spinSnippet = '<div class="spinner"></div>',
				mySwatches = mod.s7.swatches.filteredSet_;

			for (var key in mySwatches) {
				if (mySwatches.hasOwnProperty(key)) {
					if (+mySwatches[key].type === 8) {
						$('#' + mod.s7.swatches.id + ' div div').eq(0).addClass('container');
						$('#' + mod.s7.swatches.id + ' .container > div').eq(key).css({
							'position': 'absolute'
						}).append(spinSnippet);
					}
				}
			}

			mod.styleZoom();
		},

		sliderToSpinnerSync: function (event, ui) {
			var mod = this,
				goToFrame = ui.value;

			if (goToFrame >= 0 && goToFrame < mod.s7.spinview.getFramesLength()) {
				mod.s7.spinview.setCurrentFrameIndex(goToFrame);
				mod.spinviewFrameIndex = goToFrame;
			}
		},

		sliderStartDrag: function () {
			var mod = this;
			mod.elements.spinsetSpinner.data('isDragging', true);
		},

		sliderStopDrag: function () {
			var mod = this;
			mod.elements.spinsetSpinner.data('isDragging', false);
		},

		spinnerToSliderSync: function (e) {
			var mod = this,
				goToFrame = e.s7event.frame;

			if (goToFrame >= 0 && goToFrame < mod.s7.spinview.getFramesLength() && !mod.elements.spinsetSpinner.data('isDragging')) {
				mod.elements.spinsetSpinner.slider('option', 'value', goToFrame);
				mod.spinviewFrameIndex = goToFrame;
			}
		},

		toggleZoomView: function () {
			var mod = this;

			mod.$ctx.toggleClass('zoomView');
			mod.$ctx.toggleClass('normalView');

			if (mod.properties.zoomMode === 'FlyoutZoomView') {

				mod.properties.zoomMode = 'ZoomView';
				var size = mod.getWindowSize();
				mod.s7.container.resize(size.w, size.h);

				$('#scs-pageheader-logo a').css({
					'zIndex': 16200,
					'position': 'absolute',
					'left': '50px'
				});
				$('body').css({
					'overflow': 'hidden'
				});
				$(mod.s7.flyoutzoomview.obj).hide();
				if ($(mod.s7.spinview.obj).css('display') === 'block') {
					$(mod.s7.zoomview.obj).hide();
				} else {
					$(mod.s7.spinview.obj).hide();
					$(mod.s7.zoomview.obj).show();
				}
				if (mod.elements.videoButton) {
					$(mod.elements.videoButton).hide();
					mod.elements.brightcoveVideo.trigger('onPause');
					mod.elements.brightcoveVideo.hide();
				}

				$(mod.elements.containerScene7).addClass('hideBackground');

			} else {

				mod.properties.zoomMode = 'FlyoutZoomView';
				mod.s7.container.resize(mod.size.width, mod.size.height);

				$('#scs-pageheader-logo a').css({
					'zIndex': 16200,
					'position': 'relative',
					'left': 'auto'
				});
				$('body').css({
					'overflow': 'visible'
				});
				$(mod.s7.zoomview.obj).hide();
				if ($(mod.s7.spinview.obj).css('display') !== 'block') {
					$(mod.s7.spinview.obj).hide();
					$(mod.s7.flyoutzoomview.obj).show();
				}
				if (mod.elements.videoButton) {
					$(mod.elements.videoButton).show();
					mod.elements.brightcoveVideo.show();
				}

				$(mod.elements.containerScene7).removeClass('hideBackground');
			}
			mod.styleSwatches();
		},

		getWindowSize: function () {
			var size = new w.s7sdk.Point2D(),
				winW = 630,
				winH = 460;

			if (document.body && document.body.offsetWidth) {
				winW = document.body.offsetWidth;
				winH = document.body.offsetHeight;
			}
			if (document.compatMode === 'CSS1Compat' &&
				document.documentElement &&
				document.documentElement.offsetWidth) {
				winW = document.documentElement.offsetWidth;
				winH = document.documentElement.offsetHeight;
			}
			if (window.innerWidth && window.innerHeight) {
				winW = window.innerWidth;
				winH = window.innerHeight;
			}

			size.w = winW;
			size.h = winH;
			return size;
		},

		styleElements: function () {
			var mod = this;

			if (mod.properties.style === mod.STYLE['default']) {
				mod.elements.spinsetSpinner.css({
					top: (mod.size.height - 0 + 8) + 'px',
					width: (mod.size.width - mod.swatchesHeight) + 'px'
				});
				mod.elements.zoomButton.css({
					top: mod.size.height + 'px',
					'margin-left': (mod.size.width - 23) + 'px'
				});

				mod.elements.containerScene7.css({
					height: (mod.size.height - 0 + mod.swatchesHeight + mod.spinsetSpinnerExt) + 'px',
					width: mod.size.width + 'px'
				});
				if (mod.elements.videoButton) {
					mod.elements.videoButton.css({
						top: (
							mod.size.height +
							(mod.properties.style === mod.STYLE['default'] ? 58 : 38)
						) + 'px',
						'margin-left': (mod.size.width - 60) + 'px'
					});
				}

			} else {
				mod.elements.spinsetSpinner.css({
					top: (mod.size.height - 0 + 8) + 'px',
					width: (mod.size.width - mod.swatchesHeight) + 'px'
				});
				mod.elements.zoomButton.css({
					top: ''
				});

				if (mod.elements.videoButton) {
					mod.elements.videoButton.css({
						top: (mod.size.height - mod.elements.videoButton.width() - 2) + 'px'
					});
				}

				mod.elements.containerScene7.css({
					height: (mod.size.height - 0 + mod.spinsetSpinnerExt) + 'px',
					width: (mod.size.width - 0 + 110) + 'px'
				});
			}
		},

		styleZoom: function () {
			var mod = this,
				switcherContainer,
				arrowObj;

			$(mod.s7.swatches.obj).removeClass('zoomviewbackground');
			if (mod.properties.zoomMode === 'ZoomView') {
				mod.elements.zoomButton.css({
					top: ''
				});
				mod.elements.spinsetSpinner.css({
					top: '',
					width: ''
				});
				mod.elements.containerScene7.css({
					height: ''
				});
				if (mod.properties.style === mod.STYLE['default']) {
					$(mod.s7.swatches.obj).addClass('zoomviewbackground');
				}
			} else {
				mod.styleElements();
			}

			if (mod.properties.style === mod.STYLE.type1 && mod.s7.swatches) {
				switcherContainer = $(mod.s7.swatches.obj).children().first();

				arrowObj = $(mod.s7.swatches.obj).children('.s7scrollrightbutton');
				if (mod.properties.zoomMode === 'FlyoutZoomView') {
					if (arrowObj.length > 0) {
						var top = parseInt(switcherContainer.css('left'), 10) - 1;
						$(mod.s7.swatches.obj).css({
							top: '-' + top + 'px'
						});
						arrowObj = $(mod.s7.swatches.obj).children('.s7scrollrightbutton');
						mod.elements.zoomButton.css({
							top: (arrowObj.position().top - 11 - top) + 'px'
						});
						$(switcherContainer).css({
							'margin-left': '-8px'
						});
					} else {
						if (mod.elements.videoButton) {
							mod.elements.videoButton.css({
								top: (switcherContainer.position().top + switcherContainer.width() + 25 -
										(mod.$ctx.hasClass('sdxStyle') ? 29 : 0)
								) + 'px'
							});
						}
						mod.elements.zoomButton.css({
							top: (switcherContainer.position().top + switcherContainer.width() - 4) + 'px'
						});
					}
				} else {
					$(mod.s7.swatches.obj).css({
						top: ''
					});
					$(switcherContainer).css({
						'margin-left': ''
					});
				}

			}
			mod.elements.zoomButton.show();
		}
	});
}(window.Tc, window.Tc.$, window.SCS, window));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Scene7.js
// module id = 178
// module chunks = 0